import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { CheckboxChangeEventDetail, IonCheckboxCustomEvent } from '@ionic/core';
import { AppCommonModule } from 'src/app/common.module';
import { ImagesComponent } from 'src/app/components/images/images.component';
import { SelectDayComponent } from 'src/app/components/select-day/select-day.component';
import { SpeechToTextComponent } from 'src/app/components/speech-to-text/speech-to-text.component';
import { AddUser } from 'src/app/models/apartment-round.model';
import { Apartment, MaintanceRoundReport } from 'src/app/models/maintance-round.model';
import { Site } from 'src/app/models/site.model';
import { AddUserDialogComponent } from '../apartment-round/dialog/add-user.dialog';
import { maintanceRoundTemplate } from './maintrance-round.template';

@Component({
  selector: 'app-maintance-round',
  templateUrl: './maintance-round.component.html',
  styleUrls: ['./maintance-round.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    SelectDayComponent,
    FormsModule,
    SpeechToTextComponent,
    ImagesComponent,
  ],
})
export class MaintanceRoundComponent implements OnInit {
  private modalCtrl = inject(ModalController);

  site = input.required<Site>();
  users = input<AddUser[]>([]);
  existing = input<MaintanceRoundReport>(null);
  report = signal<MaintanceRoundReport>({
    description: '',
    orderDate: new Date(),
    made: new Date(),
    participants: Array.from<AddUser>([]),
    apartmentItems: [],
  });

  readonly fields = maintanceRoundTemplate;

  ngOnInit() {
    if (this.existing() != null) {
      this.report.set(this.existing());
    }
  }

  getReport() {
    return this.report();
  }

  onDateChange(value: string, field: string) {
    const date = new Date(value);
    this.report()[field] = date;
  }

  onUser(event: IonCheckboxCustomEvent<CheckboxChangeEventDetail<boolean>>, item: AddUser) {
    const checked = event.detail.checked;
    if (checked) {
      this.report().participants.push(item);
    } else {
      this.report().participants = this.report().participants.filter((it) => it.guid !== item.guid);
    }
  }

  addUser() {
    this.modalCtrl.create({ component: AddUserDialogComponent, cssClass: ['stack-modal'] }).then((m) => {
      m.present();

      m.onDidDismiss().then((data) => {
        if (data.data) {
          this.report().participants.push(data.data);
        }
      });
    });
  }

  onRemoveUser(index: number) {
    this.report().participants.splice(index, 1);
  }

  addApartment() {
    this.report().apartmentItems.push({ name: '', observations: '', images: [] });
  }

  onMic(text: string, field: string, apartment?: Apartment) {
    this.report.update((val) => {
      if (apartment) {
        const prevText = apartment[field] as string;
        apartment[field] = prevText ? `${prevText} ${text}` : text;
        return val;
      } else {
        const prevText = val[field] as string;
        val[field] = prevText ? `${prevText} ${text}` : text;
        return val;
      }
    });
  }

  onImage(field: string, url: string, apartment?: Apartment) {
    if (apartment) {
      if (apartment.images == null) {
        apartment.images = [url];
      } else {
        apartment.images.push(url);
      }
    } else {
      if (this.report()[field] == null) {
        this.report()[field] = [url];
      } else {
        this.report()[field].push(url);
      }
    }
  }

  onDeleteImage(field: string, url: string, apartment?: Apartment) {
    if (apartment) {
      apartment.images = apartment.images.filter((it: string) => it !== url);
    } else {
      this.report()[field] = this.report()[field].filter((it: string) => it !== url);
    }
  }
}
